import { render } from "./transferModal.vue?vue&type=template&id=25a79a3e"
import script from "./transferModal.vue?vue&type=script&lang=js"
export * from "./transferModal.vue?vue&type=script&lang=js"
script.render = render

export default script